import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useStyles } from './LinkingFailed.styles';
import failedImage from 'assets/images/exclamation.svg';

export const LinkingFailed: FC = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.image}>
        <img src={failedImage} alt="failed-image" />
      </Box>
      <Typography className={classes.description}>Linking process has been failed!</Typography>
      <Typography className={classes.info}>Please try again later.</Typography>
    </Box>
  );
};
